module.exports = __webpack_public_path__ + "static/image/font/pc/bmyeonsung-1@3x.ver2_0_2.jpg?acfe052f";